import React, { FunctionComponent } from 'react';
import { Campaign } from '@shared/types/mylounge';
import SpecialBanner from '@client/components/shared/SpecialBanner';
import { useVariant } from '@client/lib/assignments';

import CampaignInfo from './campaign-info';
import * as S from './campaign-label.styles';

interface Props {
    campaign: Campaign;
    categorySubline: string[];
    isSpecialDeliveryBanner: boolean;
}

export const CampaignLabel: FunctionComponent<Props> = ({
    campaign,
    categorySubline,
    isSpecialDeliveryBanner,
}) => {
    const isCampaignTitleExperiment = useVariant(
        '9df589f0-9668-4a1a-a051-cf499ec1baa8',
        'variant_campaignTitle',
    );

    return (
        <S.Container>
            {isSpecialDeliveryBanner && <SpecialBanner promise={campaign.deliveryPromise} />}
            <CampaignInfo
                campaign={campaign}
                categorySubline={categorySubline}
                isCampaignTitleExperiment={isCampaignTitleExperiment}
            />
        </S.Container>
    );
};
